import { DateTime } from 'luxon';

interface IFillRateAPI {
  time: number;
  fill_rate: number;
}

export class FillRate {
  time: DateTime;
  fillRate: number;

  constructor(time: DateTime, fillRate: number) {
    this.time = time;
    this.fillRate = fillRate;
  }

  toApi(): IFillRateAPI {
    return {
      time: this.time.toMillis(),
      fill_rate: this.fillRate,
    };
  }

  static fromApi(apiObject: IFillRateAPI): FillRate {
    return new FillRate(DateTime.fromMillis(apiObject.time), apiObject.fill_rate);
  }
}
